const CONFIG = {
    FIREBASE_TIMEOUT_MILLISECONDS: 5000,
    LOADING_BACKDROP_DELAY_TIME: 400,
    POSTS_PER_PAGE: 15,
}
export default CONFIG;